export default "/images/6c244d0388ce3e051056c799ddc0289f.png";